function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#46C1F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#29AAE2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#46C1F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#29AAE2"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 9,
  cy: 4.286,
  stroke: "url(#g)",
  rx: 3.75,
  ry: 3.536
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#h)",
  d: "M.85 16.765A14.464 14.464 0 0 0 9 19.25a14.46 14.46 0 0 0 8.15-2.485C16.172 13.26 12.856 10.75 9 10.75c-3.856 0-7.172 2.512-8.15 6.015z"
}));

var SvgName = function SvgName(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgName, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/name.4e45cabb.svg";
export { ForwardRef as ReactComponent };